module.exports = __webpack_public_path__ + "static/strawberry-bol.eee1edf7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/hero/strawberry-bol.jpg
// module id = 1046
// module chunks = 213534597649335